<template>
	<section>
		<h1>Ajouter une classe</h1>
		<form @submit.prevent="submit">
			<div class="input-container">
				<input
					id="name"
					v-model="form.name"
					name="name"
					type="text"
					placeholder=" "
				/>
				<label class="custom-label" for="name">Nom de la classe</label>
			</div>
			<div class="input-container">
				<select
					class="days"
					v-model="form.level"
					name="level"
					id="level"
				>
					<option value="" selected disabled hidden>
						Niveau de la classe
					</option>
					<option
						v-for="level in availableLevels"
						:key="level"
						:value="level.id"
					>
						{{ level.name }}
					</option>
				</select>
			</div>
			<div class="error-container">
				<p v-if="errors !== ''">{{ errors }}</p>
			</div>
			<input class="submit dark" type="submit" value="Valider" />
		</form>
		<pop-up-question
			:id="
				this.$store.state.classes[this.$store.state.classes.length - 1]
					.id
			"
			v-if="showPopUp"
		/>
	</section>
</template>

<script>
import PopUpQuestion from '../../PopUp/PopUpClasse.vue'

export default {
	components: {
		PopUpQuestion
	},
	data() {
		return {
			form: {
				name: '',
				level: '',
				teacher: localStorage.userId
			},
			levels: [],
			errors: '',
			isOk: false,
			isFirstTime: true
		}
	},
	methods: {
		submit() {
			if (this.form.name == '' || this.form.level == '') {
				this.errors = 'Veuillez remplir les champs manquants'
			}
			else {
				// Vérification de sécurité : s'assurer que l'utilisateur a le droit de créer une classe pour ce niveau
				const userLevels = this.$store.state.user.levels || []
				if (!userLevels.includes(this.form.level)) {
					this.errors = 'Vous n\'avez pas les permissions pour créer une classe de ce niveau'
					return
				}
				
				this.$store.dispatch('addClass', this.form)
					.then(() => {
						this.isOk = true
					})
					.catch((error) => {
						this.errors = error.response.data
					})
			}
		},
	},
	computed: {
		showPopUp() {
			if (this.isOk) {
				return true
			}
			else {
				return false
			}
		},
		availableLevels() {
			// Filtrer les niveaux selon les niveaux autorisés de l'utilisateur
			const userLevels = this.$store.state.user.levels || []
			return this.$store.state.levels.filter(level => {
				// L'utilisateur ne peut créer des classes que pour ses niveaux autorisés
				return userLevels.includes(level.id)
			})
		}
	},

}
</script>

<style>
</style>
